module.exports = "/wp-content/themes/aly-2-markkinointisaitti/static/images/quote-white.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/icons/quote-white.svg
// module id = 23
// module chunks = 2